import { useMutation } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { IUseAdminLoginMutationResponse } from "../utils/types";

const useAdminLoginMutation = (): IUseAdminLoginMutationResponse =>
  useMutation({
    mutationFn: async (data) => {
      const response = await AXIOS_RESERVATION.post("v1/staff/login", data);
      return response.data;
    },
  });

export default useAdminLoginMutation;
